import type { JSX, ReactNode } from 'react';
import { useChronicle } from '../useChronicle';
import { ChronicleFeed } from './ChronicleFeed';
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from './ui/sheet';

/**
 * The chronicle behind any trigger: a bottom sheet on a phone, a right-hand panel from `lg` up.
 *
 * Each mount owns its own `Sheet` rather than sharing one lifted open state — the header and the
 * landing rail sit in different subtrees, and `useChronicle` already shares the one cache entry.
 */

/** `side="bottom"` and widened by class, so no media query has to run before the panel can render. */
const PANEL =
  'h-[85vh] gap-0 overflow-y-auto rounded-t-lg p-4 lg:inset-y-0 lg:right-0 lg:left-auto lg:h-full lg:max-w-none lg:w-[26rem] lg:rounded-none lg:border-t-0 lg:border-l lg:data-[state=closed]:slide-out-to-right lg:data-[state=open]:slide-in-from-right';

export function ChronicleSheet({ trigger }: { trigger: ReactNode }): JSX.Element {
  const chronicle = useChronicle();

  return (
    <Sheet>
      <SheetTrigger asChild>{trigger}</SheetTrigger>
      <SheetContent side="bottom" className={PANEL}>
        {/* Radix needs a title for the dialog and the panel already prints one, so the panel's own
            heading *is* the title — announcing it twice is the same claim read out twice. */}
        <ChronicleFeed chronicle={chronicle} titleAs={SheetTitle} />
      </SheetContent>
    </Sheet>
  );
}
